import axios from 'axios';

const baseDomain = process.env.VUE_APP_RESEARCH_API_SERVER_URL;
const baseURL = `${baseDomain}/api/v1`;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default axios.create({
  baseURL,
  timeout: 25000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  responseType: 'json',
});
